import axios from 'axios';

// 創建 axios 實例
const apiClient = axios.create({
    baseURL: import.meta.env.VITE_API_URL, // 直接使用環境變量中的 URL
    timeout: 120000, // 請求超時時間
    headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
    }
});

// 請求攔截器
apiClient.interceptors.request.use(
    config => {
        // 從 localStorage 獲取 token
        const token = localStorage.getItem('token');
        if (token) {
            config.headers.Authorization = `Bearer ${token}`;
        }
        return config;
    },
    error => {
        return Promise.reject(error);
    }
);

// 響應攔截器
apiClient.interceptors.response.use(
    response => response,
    error => {
        if (error.response) {
            // 處理特定的錯誤狀態
            switch (error.response.status) {
                case 401:
                    // 未授權，可以在這裡處理登出邏輯
                    break;
                case 404:
                    // 資源不存在
                    break;
                case 500:
                    // 服務器錯誤
                    break;
            }
        }
        return Promise.reject(error);
    }
);

export default apiClient; 
